var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedSendCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#EB2726"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7345 20.1654L11.1095 9.85292C10.9479 9.77207 10.7663 9.73968 10.5867 9.75964C10.407 9.7796 10.237 9.85106 10.097 9.96542C9.96338 10.0774 9.86361 10.2245 9.80896 10.3901C9.7543 10.5558 9.74693 10.7333 9.78767 10.9029L12.272 20.0623H22.8752V21.9373H12.272L9.75017 31.0685C9.71194 31.2102 9.70748 31.3588 9.73714 31.5024C9.7668 31.6461 9.82975 31.7808 9.92094 31.8957C10.0121 32.0106 10.129 32.1024 10.2622 32.164C10.3953 32.2255 10.5411 32.2549 10.6877 32.2498C10.8344 32.2489 10.9789 32.2136 11.1095 32.1467L31.7345 21.8342C31.8881 21.7555 32.017 21.636 32.107 21.4888C32.197 21.3415 32.2446 21.1723 32.2446 20.9998C32.2446 20.8272 32.197 20.6581 32.107 20.5108C32.017 20.3636 31.8881 20.2441 31.7345 20.1654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSendCircle);
export default __webpack_public_path__ + "static/media/Red-Send-Circle.3a9b8c92caecc5005cfa57f52c866521.svg";
export { ForwardRef as ReactComponent };